import React from 'react';
import { Link } from 'react-router-dom';
interface Category {
  id: string;
  name: string;
}
interface NewsCategoriesProps {
  categories: Category[];
  activeCategory?: string;
}
export const NewsCategories = ({
  categories,
  activeCategory = 'all'
}: NewsCategoriesProps) => {
  return <div className="mb-8 overflow-x-auto" data-id="element-179">
      <div className="flex space-x-2 pb-2" data-id="element-180">
        {categories.map(category => <Link key={category.id} to={category.id === 'all' ? '/' : `/category/${category.id}`} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === category.id ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-181">
            {category.name}
          </Link>)}
      </div>
    </div>;
};